/* global Papa */

'use strict';

// Constructor
var Table = function () {

    $('.csv-table').each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data('configuration'); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : '';
        var $decimal_places = typeof $configuration.decimal_places === 'undefined' ? false : $configuration.decimal_places; //Decimal places to show
        var $raw_value = typeof $configuration.raw_value === 'undefined' ? false : $configuration.raw_value; //Decimal places to show

        // console.log($table_css_class);

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {


                // Process the data
                $configuration.header ? $header = $json.data.shift() : '';
                $configuration.footer ? $footer = $json.data.pop() : '';

                // Output the HTML structure for the table
                var $html = "";
                $html += '<table class="' + $table_css_class + '">';
                if ($configuration.header) {
                    $html += '<thead><tr>';
                    $($header).each(function ($index, $value) {
                        $html += '<th>' + $value + '</th>';
                    });
                    $html += '</tr></thead>';
                }
                if ($json.data) {
                    $html += '<tbody>';
                    $($json.data).each(function ($index, $row) {

                        // Special case #87586
                        if ($row.length === 2) {
                            if ($row[0] === 'Patents' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                            if ($row[0] === 'FTEs' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                            if ($row[0] === 'Research outputs' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                        }

                        $html += '<tr>';
                        $($row).each(function ($index, $cell) {
                            if ($raw_value) {
                                // Do nothing
                            } else {
                                if ($decimal_places && $index !== 0 && $cell !== '-' && $cell !== '–') {
                                    $cell = Number(parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places)).toLocaleString(undefined, { minimumFractionDigits: $decimal_places });
                                }
                            }
                            $html += '<td>' + $cell + '</td>';
                        });
                        $html += '</tr>';
                    });
                    $html += '</tbody>';
                }
                if ($configuration.footer) {
                    $html += '<tfoot><tr>';
                    $($footer).each(function ($index, $value) {
                        if ($raw_value) {
                            // Do nothing
                        } else {
                            if ($decimal_places && $index !== 0 && $value !== '-' && $value !== '–') {
                                $value = parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                            }
                        }
                        $html += '<td>' + $value + '</td>';
                    });
                    $html += '</tr></tfoot>';
                }
                $html += '</table>';

                $container.html($html);


                // Make the dataTable
                var $columnsDefs;

                // Show only 8 columns on the display
                if ($header.length > 8 && $configuration['limit_cols_to_8']) {
                    $columnsDefs = [
                        {
                            "targets": [1, 2, 3, 4, 5, 6, 7, 8], // We can make this a configuration
                            "visible": true
                        },
                        {
                            "targets": ['_all'],
                            "visible": false
                        }
                    ];
                    $configuration['columnDefs'] = $columnsDefs;
                }


                if ($configuration['stick_left_col'] && window.innerWidth > 1200) {
                    // $configuration['fixedColumns'] = {leftColumns: 1};
                    // $configuration['scrollX'] = true;
                }
                if (window.innerWidth <= 1200) {
                    // $configuration['scrollX'] = true;
                }

                // $container.find('table').DataTable($configuration);
                if (!$configuration['nodatatable']) {
                    $container.find('table').DataTable($configuration);
                }
            },
            error: function ($err, $file, $inputElem, $reason) {
                $container.closest('.collapsible-box').addClass('no-data');
                if ($err['message'] === 'Not Found' || $err['message'] === '') {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + 'no.table.footnote.txt'; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    }).done(function ($data) {
                        $data ? $error_message = $data : '';
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    }).fail(function ($error) {
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    });
                }
            }
        });
    });
};

module.exports = Table;
